import type { DocumentVersion } from "@/types/container";

// Mock data per document versions
// Creiamo versioni storiche per alcuni documenti
const mockDocumentVersions: DocumentVersion[] = [
    // Documento 1 (Bill of Lading - TCLU1234567) - 3 versioni
    {
        id: "v1-1",
        documentId: "1",
        version: 1,
        uploadedAt: new Date("2024-01-20T10:30:00"),
        uploadedBy: {
            name: "John Smith",
            email: "john.smith@example.com",
        },
        extractedData: {
            "B/L No": "TCLU1234567",
            SCAC: "TCLU",
            Vessel: "MSC LORETO",
            "Port of Loading": "New York, USA",
            Shipper: "TechCorp Solutions LLC",
            Consignee: "Global Partners Corp",
        },
        fileName: "Bill of Lading - TCLU1234567-v1.pdf",
        fileSizeKB: 1250,
    },
    {
        id: "v1-2",
        documentId: "1",
        version: 2,
        uploadedAt: new Date("2024-01-21T14:15:00"),
        uploadedBy: {
            name: "Sarah Johnson",
            email: "sarah.johnson@example.com",
        },
        extractedData: {
            "B/L No": "TCLU1234567",
            SCAC: "TCLU",
            Vessel: "MSC LORETO",
            "Port of Loading": "New York, USA",
            Shipper: "TechCorp Solutions LLC",
            Consignee: "Global Partners Corp",
        },
        fileName: "Bill of Lading - TCLU1234567-v2.pdf",
        fileSizeKB: 1280,
    },
    {
        id: "v1-3",
        documentId: "1",
        version: 3,
        uploadedAt: new Date("2024-01-22T09:45:00"),
        uploadedBy: {
            name: "Michael Brown",
            email: "michael.brown@example.com",
        },
        extractedData: {
            "B/L No": "TCLU1234567",
            SCAC: "TCLU",
            Vessel: "MSC LORETO",
            "Port of Loading": "New York, USA",
            Shipper: "TechCorp Solutions LLC",
            Consignee: "Global Partners Corp",
        },
        fileName: "Bill of Lading - TCLU1234567-v3.pdf",
        fileSizeKB: 1320,
    },

    // Documento 2 (Commercial Invoice - TCLU1234567) - 2 versioni
    {
        id: "v2-1",
        documentId: "2",
        version: 1,
        uploadedAt: new Date("2024-01-22T11:20:00"),
        uploadedBy: {
            name: "Emma Wilson",
            email: "emma.wilson@example.com",
        },
        extractedData: {
            "Invoice No": "INV-2024-001",
            "Invoice Date": "2024-01-20",
            "Total Amount": "$120,000.00",
            "Bank Details": "Chase Bank, New York",
        },
        fileName: "Commercial Invoice - TCLU1234567-v1.pdf",
        fileSizeKB: 850,
    },
    {
        id: "v2-2",
        documentId: "2",
        version: 2,
        uploadedAt: new Date("2024-01-23T16:30:00"),
        uploadedBy: {
            name: "Emma Wilson",
            email: "emma.wilson@example.com",
        },
        extractedData: {
            "Invoice No": "INV-2024-001",
            "Invoice Date": "2024-01-20",
            "Total Amount": "$125,000.00",
            "Bank Details": "Chase Bank, New York",
            "Unit Price": "$1,250.00",
        },
        fileName: "Commercial Invoice - TCLU1234567-v2.pdf",
        fileSizeKB: 920,
    },

    // Documento 6 (Commercial Invoice - TCLU1234568) - 4 versioni
    {
        id: "v6-1",
        documentId: "6",
        version: 1,
        uploadedAt: new Date("2024-01-27T08:15:00"),
        uploadedBy: {
            name: "David Martinez",
            email: "david.martinez@example.com",
        },
        extractedData: {
            "Invoice No": "INV-2024-002",
            "Invoice Date": "2024-01-25",
            "Total Amount": "$80,000.00",
        },
        fileName: "Commercial Invoice - TCLU1234568-v1.pdf",
        fileSizeKB: 780,
    },
    {
        id: "v6-2",
        documentId: "6",
        version: 2,
        uploadedAt: new Date("2024-01-27T14:45:00"),
        uploadedBy: {
            name: "David Martinez",
            email: "david.martinez@example.com",
        },
        extractedData: {
            "Invoice No": "INV-2024-002",
            "Invoice Date": "2024-01-25",
            "Total Amount": "$82,000.00",
            "Bank Details": "Chase Bank, New York",
        },
        fileName: "Commercial Invoice - TCLU1234568-v2.pdf",
        fileSizeKB: 810,
    },
    {
        id: "v6-3",
        documentId: "6",
        version: 3,
        uploadedAt: new Date("2024-01-28T10:20:00"),
        uploadedBy: {
            name: "Lisa Anderson",
            email: "lisa.anderson@example.com",
        },
        extractedData: {
            "Invoice No": "INV-2024-002",
            "Invoice Date": "2024-01-25",
            "Total Amount": "$85,000.00",
            "Bank Details": "Chase Bank, New York",
        },
        fileName: "Commercial Invoice - TCLU1234568-v3.pdf",
        fileSizeKB: 830,
    },
    {
        id: "v6-4",
        documentId: "6",
        version: 4,
        uploadedAt: new Date("2024-01-28T15:00:00"),
        uploadedBy: {
            name: "Lisa Anderson",
            email: "lisa.anderson@example.com",
        },
        extractedData: {
            "Invoice No": "INV-2024-002",
            "Invoice Date": "2024-01-25",
            "Total Amount": "$85,000.00",
            "Bank Details": "Chase Bank, New York",
        },
        fileName: "Commercial Invoice - TCLU1234568-v4.pdf",
        fileSizeKB: 835,
    },

    // Documento 4 (Bill of Lading - TCLU1234568) - 2 versioni
    {
        id: "v4-1",
        documentId: "4",
        version: 1,
        uploadedAt: new Date("2024-01-25T09:00:00"),
        uploadedBy: {
            name: "Robert Taylor",
            email: "robert.taylor@example.com",
        },
        extractedData: {
            "B/L No": "TCLU1234568",
            SCAC: "TCLU",
            Vessel: "MSC LORETO",
            "Port of Loading": "New York, USA",
            Shipper: "TechCorp Solutions LLC",
            Consignee: "Green Future NGO",
        },
        fileName: "Bill of Lading - TCLU1234568-v1.pdf",
        fileSizeKB: 1180,
    },
    {
        id: "v4-2",
        documentId: "4",
        version: 2,
        uploadedAt: new Date("2024-01-26T11:30:00"),
        uploadedBy: {
            name: "Robert Taylor",
            email: "robert.taylor@example.com",
        },
        extractedData: {
            "B/L No": "TCLU1234568",
            SCAC: "TCLU",
            Vessel: "MSC LORETO",
            "Port of Loading": "New York, USA",
            Shipper: "TechCorp Solutions LLC",
            Consignee: "Green Future NGO",
        },
        fileName: "Bill of Lading - TCLU1234568-v2.pdf",
        fileSizeKB: 1220,
    },
];

// In-memory storage
let documentVersions = [...mockDocumentVersions];

// Service per gestire le versioni dei documenti
export const documentVersionService = {
    // Get all versions for a document
    getByDocumentId: (documentId: string): DocumentVersion[] => {
        return documentVersions
            .filter((version) => version.documentId === documentId)
            .sort((a, b) => b.version - a.version); // Ordina per versione decrescente (più recente prima)
    },

    // Get latest version for a document
    getLatestVersion: (documentId: string): DocumentVersion | undefined => {
        const versions = documentVersions
            .filter((version) => version.documentId === documentId)
            .sort((a, b) => b.version - a.version);
        return versions[0];
    },

    // Get version by ID
    getById: (id: string): DocumentVersion | undefined => {
        return documentVersions.find((version) => version.id === id);
    },

    // Create new version
    create: (data: Omit<DocumentVersion, "id">): DocumentVersion => {
        const existingVersions = documentVersions.filter(
            (v) => v.documentId === data.documentId
        );
        const nextVersion = existingVersions.length > 0
            ? Math.max(...existingVersions.map((v) => v.version)) + 1
            : 1;

        const newVersion: DocumentVersion = {
            id: `v${data.documentId}-${nextVersion}`,
            ...data,
            version: nextVersion,
        };
        documentVersions.push(newVersion);
        return newVersion;
    },
};

